import {getAuth, connectAuthEmulator} from 'firebase/auth';
import {getFirebaseApp} from '@local/logics/firebase/app';
// getFirebaseApp();
const auth = getAuth(getFirebaseApp());
// const auth = getAuth();
if (process.env.NEXT_PUBLIC_FIREBASE_AUTH_EMULATOR_HOST) {
  connectAuthEmulator(auth, process.env.NEXT_PUBLIC_FIREBASE_AUTH_EMULATOR_HOST);
}
export const getFirebaseAuth = () => auth;
